import * as yup from "yup";
import { pt } from 'yup-locale-pt';
yup.setLocale(pt);

yup.addMethod(yup.array,'emailList',function isValidEmailList() {
  return this.transform(function(value, originalValue) {
    if (this.isType(value) && value !== null) {
      return value;
    }
    return originalValue ? originalValue.split(/[\s,]+/) : [];
  })
    .of(yup.string().email(({ value }) => `${value} não é um email válido`));
});
